<template>
  <span v-if="ratio === null || ratio === undefined" class="grey--text">—</span>
  <span v-else class="bm-num d-inline-flex flex-column align-end" style="line-height: 1.25">
    <span class="d-inline-flex align-center">
      <span class="bm-bar"><i :style="{ width: width + '%', background: bandHex(band) }"></i></span>
      <strong>{{ formatPct(ratio) }}</strong>
    </span>
    <span
      v-if="projected !== null && projected !== undefined"
      class="bm-tiny font-weight-medium"
      :style="{ color: projectedHex }"
      :title="'Proyeksi akhir bila sisa BOM dibeli dengan harga terakhir: ' + formatPct(projected)"
      >→ {{ formatPct(projected) }} akhir</span
    >
  </span>
</template>

<script>
import { bandHex, formatPct } from "@/utils/budgetMonitor";

/** Ratio % with a small bar tinted by band (full at 100 %); second line = projected final ratio. */
export default {
  name: "ratio-cell",
  props: {
    ratio: { type: [Number, String], default: null },
    band: { type: String, default: "NO_BUDGET" },
    projected: { type: [Number, String], default: null },
    projectedBand: { type: String, default: null },
  },
  computed: {
    width() {
      return Math.max(0, Math.min(100, Number(this.ratio) || 0));
    },
    projectedHex() {
      // darker shades than the bar so the small text stays readable
      const b = this.projectedBand || this.band;
      return b === "RED"
        ? "#B71C1C"
        : b === "YELLOW"
        ? "#E65100"
        : b === "GREEN"
        ? "#2E7D32"
        : "#616161";
    },
  },
  methods: { bandHex, formatPct },
};
</script>
